import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import * as toastr from 'toastr';
import commonActions from './commonActions';
import { Button } from '../components/buttons';
import { Page, PageContent, PageHeaderFullWidth, Spinner } from '../components/common';
import { TextArea, TextInput, ToggleSwitch } from '../components/forms';
import Utils, { Validation, InputError } from '../common/utils';

interface Props {
	actions: any;
	history: any;
}
interface State {
	form: {
		name: string;
		email: string;
		phone: string;
		message: string;
		preferredCommunication: string;
	};
	touched: {
		email: boolean;
	};
	loading: boolean;
}
class ContactUsPage extends React.Component<Props, State> {
	errors = { email: {} as InputError };
	constructor(props: Props) {
		super(props);
		this.state = this.getInitialState();
	}

	getInitialState = () => {
		return {
			form: {
				name: '',
				email: '',
				phone: '',
				message: '',
				preferredCommunication: ''
			},
			touched: {
				email: false
			},
			loading: false
		};
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}
	onFormChange = (e: any) => {
		let value = e.target.value;
		if (e.target.type === 'radio') {
			if (value === 'true') {
				value = 'email';
			} else if (value === 'false') {
				value = 'phone';
			}
		}

		const form = { ...this.state.form, [e.target.name]: value };
		this.setState({ form });
	}
	onPhoneKeyUp = (e: any) => {
		let phone = e.target.value;
		phone = phone
			.match(/\d*/g)
			.join('')
			.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
			.slice(1)
			.join('-')
			.replace(/-*$/g, '');

		const form = { ...this.state.form, phone };
		this.setState({ form });
	}

	isSubmitDisabled = () => {
		const { form } = this.state;
		if (!form.name || !form.preferredCommunication || !form.message) {
			return true;
		}

		if (form.preferredCommunication === 'email' && !form.email) {
			return true;
		}

		if (form.preferredCommunication === 'phone' && !form.phone) {
			return true;
		}

		if (form.email !== '') {
			return this.errors.email.hasError;
		}

		if (this.state.loading) {
			return true;
		}

		return false;
	}

	onSubmit = () => {
		this.setState({ loading: true });
		this.props.actions.contactUs(this.state.form)
			.then(() => {
				this.setState(this.getInitialState());
				toastr.success('Your message has been sent! We will contact you as soon as we can.');
			});
	}
	validate = () => {
		// true means invalid
		return {
			email: Validation.validateEmail(this.state.form.email)
		};
	}

	render() {
		this.errors = this.validate();
		return (
			<Page>
				<Helmet>
					<meta charSet="utf-8"/>
					<meta
						name="description"
						content={`If you have questions about life insurance, contact Mosaic Life by phone or fill out our contact form and we'll be glad to help.`}
					/>
					<title>Contact Us | Mosaic Life</title>
				</Helmet>
				<PageContent>
					<PageHeaderFullWidth title="Contact Us">
						<p>We’re taking insurance online but we’re not robots.  Please drop us a line if you have any questions.</p>
					</PageHeaderFullWidth>
					<div className="form-fieldset">
						<div className="row">
							<TextInput
								id="name"
								labelText="Name"
								name="name"
								onChange={this.onFormChange}
								value={this.state.form.name}
								className="col-md-6"
							/>
							<ToggleSwitch
								labelText="Preferred Communication"
								id="preferredCommunication"
								name="preferredCommunication"
								onChildren="Email"
								offChildren="Phone"
								onChange={this.onFormChange}
								checked={this.state.form.preferredCommunication === '' ?
									undefined : this.state.form.preferredCommunication === 'email'}
								className="col-md-6 toggle-do-donot"
							/>
							<TextInput
								id="email"
								labelText="Email"
								name="email"
								onBlur={this.handleBlur('email')}
								onChange={this.onFormChange}
								value={this.state.form.email}
								className="col-md-6"
								error={Utils.shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined}
							/>
							<TextInput
								id="phone"
								labelText="Phone"
								name="phone"
								onChange={this.onFormChange}
								onKeyUp={this.onPhoneKeyUp}
								value={this.state.form.phone}
								className="col-md-6"
							/>
							<TextArea
								id="message"
								labelText="Message"
								name="message"
								onChange={this.onFormChange}
								value={this.state.form.message}
								className="col-md-12"
							/>
						</div>
					</div>
					<Button onClick={this.onSubmit} className="btn-primary mt-4" disabled={this.isSubmitDisabled()}>
						Submit {this.state.loading && <Spinner />}
					</Button>
					<Button className="float-right mt-4 btn btn-link" onClick={this.redirectToComplaints}>
						Have a complaint?
					</Button>
				</PageContent>
			</Page>
		);
	}

	private redirectToComplaints = () => {
		this.props.history.push(`/complaints`);
	}
}

function mapDispatchToProps(dispatch: any) {
	const actions = { ...commonActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(null, mapDispatchToProps)(ContactUsPage);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/ContactUsPage.tsx